import Vue from 'vue'
import { mapState } from 'vuex'
import snackMixin from '@/mixins/snackMixin'
import { RootState } from '@/store'
import { applicationManageMixin, archivableMixin, reportableMixin } from '../mixins'

export default Vue.extend<any, any, any, any>({
  mixins: [applicationManageMixin, archivableMixin, reportableMixin, snackMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.vacancyChat.application.value,
    }),
  },
  methods: {
    onReportClick() {
      this.reportUser()
    },
    onDeclineApplicationByCustomerClick() {
      this.declineApplicationByCustomer()
    },
    onCancelApplicationByFreelancerClick() {
      this.declineApplicationByFreelancer()
    },
    async onRemoveFromArchivedClick() {
      if (this.archiving) return

      await this.setArchivedMeta(false)
      this.openSnackbar({
        text: 'Application was unarchived',
      })
    },
  },
})
